import { defineComponent as n, Types as t } from "bitecs";
var u = /* @__PURE__ */ ((i) => (i[i.Additive = 0] = "Additive", i[i.Multiplicative = 1] = "Multiplicative", i))(u || {});
const c = n({
  target: t.eid,
  value: t.f32,
  intensity: t.f32,
  mode: t.ui8
}), g = n({
  duration: t.f32,
  elapsed: t.f32,
  easingIndex: t.ui8
}), v = n({
  source: t.ui32,
  target: t.ui32,
  componentId: t.ui32,
  fieldIndex: t.ui32,
  from: t.f32,
  to: t.f32,
  value: t.f32
}), X = n({
  tweenEntity: t.ui32,
  targetEntity: t.ui32,
  axis: t.ui8,
  from: t.f32,
  to: t.f32,
  lastPosition: t.f32,
  targetPosition: t.f32
}), Y = n({
  tweenEntity: t.ui32,
  targetEntity: t.ui32,
  axis: t.ui8,
  from: t.f32,
  to: t.f32,
  lastRotation: t.f32,
  targetRotation: t.f32
});
var o = /* @__PURE__ */ ((i) => (i[i.Idle = 0] = "Idle", i[i.Playing = 1] = "Playing", i))(o || {});
const Z = n({
  state: t.ui8,
  currentIndex: t.ui32,
  itemCount: t.ui32,
  pauseRemaining: t.f32
});
var l = /* @__PURE__ */ ((i) => (i[i.Position = 0] = "Position", i[i.Scale = 1] = "Scale", i[i.Rotation = 2] = "Rotation", i))(l || {}), d = /* @__PURE__ */ ((i) => (i[i.X = 1] = "X", i[i.Y = 2] = "Y", i[i.Z = 4] = "Z", i[i.XY = 3] = "XY", i[i.XZ = 5] = "XZ", i[i.YZ = 6] = "YZ", i[i.XYZ = 7] = "XYZ", i))(d || {});
const f = n({
  target: t.eid,
  type: t.ui8,
  axes: t.ui8,
  value: t.f32,
  intensity: t.f32,
  mode: t.ui8
});
export {
  Y as KinematicRotationTween,
  X as KinematicTween,
  Z as Sequence,
  o as SequenceState,
  c as Shaker,
  u as ShakerMode,
  f as TransformShaker,
  d as TransformShakerAxes,
  l as TransformShakerType,
  g as Tween,
  v as TweenValue
};
//# sourceMappingURL=components.js.map
